module.exports = __webpack_public_path__ + "img/xianhua.87eb8572.png";